import React, { useState } from 'react';
import {
    Row,
    Col,
    Input,
    Form,
    Button,
    DatePicker,
    AutoComplete,
    message,
    Typography,
    Divider
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import axios from '../../../config/axios';
import rawProvince from '../../../utils/province.json';

export default function EditProfile({ userData }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [result, setResult] = useState([]);
    const [form] = Form.useForm();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .post(`/api/user/updateProfile`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => queryClient.invalidateQueries(['/api/user/updateProfile'])
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onFinish = (values) => {
        mutate(values);
    }

    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    // console.log(userData);
    return (
        <div>
            {contextHolder}
            <Typography.Title level={5}>
                แก้ไขข้อมูลส่วนตัว
            </Typography.Title>
            <Divider />
            <Row justify='space-between' >
                <Col xs={24}>
                    <Form
                        name="createEmployee"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                        initialValues={{
                            ...userData.employee,
                            birth_date: userData.employee && dayjs(userData.employee?.birth_date)
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ชื่อ"
                                            name="fname"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="นามสกุล"
                                            name="lname"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="เบอร์โทรศัพท์"
                                            name="phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="อีเมล์"
                                            name="email"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="หมายเลขประจำตัวผู้เสียภาษี/หมายเลขบัตรประชาชน"
                                            name="idcard"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="วัน เดือน ปี เกิด"
                                            name="birth_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item name="address" label="ที่อยู่">
                                            <Input.TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ตำบล"
                                            name="sub_district"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleDistrictSearch}
                                            >
                                                {result.map((tam) => (
                                                    <AutoComplete.Option key={tam} value={tam}>
                                                        {tam}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="อำเภอ"
                                            name="district"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleAmphoeSearch}
                                            >
                                                {result.map((amp) => (
                                                    <AutoComplete.Option key={amp} value={amp}>
                                                        {amp}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="จังหวัด"
                                            name="province"
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleProvinceSearch}
                                            >
                                                {result.map((prov) => (
                                                    <AutoComplete.Option key={prov} value={prov}>
                                                        {prov}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="รหัสไปรษณีย์"
                                            name="postalcode"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} >
                                        <Row justify="end">
                                            <Col>
                                                <Form.Item>
                                                    <Button type="primary" htmlType="submit" disabled={isLoading}>
                                                        บันทึก
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}
